module.exports = __webpack_public_path__ + "img/avatar-slug2.1f44a085.jpg";